export default __webpack_public_path__ + "cf78d560e2e3cbe7608f306db918d78b.png";